module.exports = __webpack_public_path__ + "static/img/opt_1.bf27133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo_sur/opt_1.png
// module id = W7PK
// module chunks = 0